export default __webpack_public_path__ + "static/media/player_pause.d29c0877.svg";